export interface CaseStudy {
  tag: string;
  title: string;
  prob: string;
  sol: string;
  res: string[];
  pkg: string;
}

export const CASES: CaseStudy[] = [
  {
    tag: "Restaurant · Toronto",
    title: "From Zero Presence to Fully Booked Weekends",
    prob: "No social media, no reviews, competing with larger chains. Weekend bookings were inconsistent with zero ability to attract new customers digitally.",
    sol: "Launched RevBoost — 16 short-form videos/month showcasing food prep, ambiance, and staff. Optimized Google Business Profile, set up review generation, and ran targeted local Meta Ads within 10km.",
    res: [
      "3× increase in Google profile views in 60 days",
      "40% increase in weekend foot traffic in 90 days",
      "Ranked #1 on Google Maps in their neighborhood",
      "2,200 new Instagram followers in 3 months",
    ],
    pkg: "RevBoost",
  },
  {
    tag: "Salon · Vancouver",
    title: "Word-of-Mouth to 1,800 New Followers in 60 Days",
    prob: "Fully relying on word-of-mouth with no digital presence, no online booking, and seasonal revenue dips killing cash flow.",
    sol: "Launched before/after transformation video series on Instagram and TikTok. Content calendar around seasonal promotions. Implemented RevSync: CRM, automated booking confirmations, and a post-visit email sequence.",
    res: [
      "1,800 new Instagram followers in 60 days",
      "Bookings increased 60% in 3 months",
      "Email list of 400+ active clients in first quarter",
      "Seasonal dips eliminated — fully booked 6 weeks ahead",
    ],
    pkg: "RevMax + RevSync",
  },
  {
    tag: "Barbershop · Calgary",
    title: "New Location to #1 on Google in 45 Days",
    prob: "Brand new location, zero online presence, no reviews, and heavy competition from established local shops with loyal followings.",
    sol: "Built their entire digital presence from scratch: Google Business Profile, RevBase social content around shop culture and client transformations, and RevFlow automation with booking integration and automated follow-ups.",
    res: [
      "Ranked #1 on Google Maps in 45 days",
      "25 new client bookings in first month",
      "4.9★ Google rating with 80+ reviews in 90 days",
      "Fully booked calendar within 4 months of opening",
    ],
    pkg: "RevBase + RevFlow",
  },
];
